import { ConfigProvider } from "antd";
import Footer from "components/footer/Footer";
import Header from "components/Header";
import { LocalContext } from "context/AuthenticationContext";
import { Component, ReactNode } from "react";
import { NavigateFunction } from "react-router-dom";
import { colorFormat } from "utils/format/ColorFormat";
import Sidebar from "../sidebar/presentation/Sidebar";

interface IMainFeature {
  children?: ReactNode;
  location?: Location;
  navigate?: NavigateFunction;
}

interface IMainState {
  sidebarOpen: boolean;
}

class Main extends Component<IMainFeature, IMainState> {
  static contextType = LocalContext;
  context: React.ContextType<typeof LocalContext>;
  constructor(props: IMainFeature) {
    super(props);
    this.state = {
      sidebarOpen: false,
    };

    this.setSidebarOpen = this.setSidebarOpen.bind(this);
  }

  setSidebarOpen(open: boolean) {
    this.setState({ sidebarOpen: open });
  }

  render() {
    const { children, location, navigate } = this.props;
    const { sidebarOpen } = this.state;

    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: colorFormat?.Blue,
            colorError: colorFormat?.Red_Dark,
          },
          components: {
            Menu: {
              itemColor: colorFormat?.Black,
              itemBg: "transparent",
              subMenuItemBg: "transparent",
              itemSelectedColor: colorFormat?.Blue,
              itemSelectedBg: "transparent",
              itemActiveBg: "transparent",
            },
          },
        }}
      >
        <section className="flex h-screen overflow-hidden">
          <Sidebar
            sidebarOpen={sidebarOpen}
            location={location}
            navigate={navigate}
            setSidebarOpen={this.setSidebarOpen}
          />
          <div className="relative flex flex-col flex-1 overflow-y-auto">
            <Header
              sidebarOpen={sidebarOpen}
              setSidebarOpen={this.setSidebarOpen}
            />
            <main className="flex-1">{children}</main>
            <Footer />
          </div>
        </section>
      </ConfigProvider>
    );
  }
}

export default Main;
